import { createTheme } from "@mui/material";
import { deDE as coreDeDE } from '@mui/material/locale';
import { HeaderLayout, ThemeCustomizing } from "../types/types";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

export const RHION_THEME_V2 = () => {
    const customizing = {
        headerLayout: HeaderLayout.FIXED_FULL_WIDTH,
        colors: {
          background: "#ffffff",
          font: "#000000",
          primary: "#0099cc",
          primaryContrast: "#e5f4f9",
          secondary: "#A4D084",
          secondaryContrast: "#f5faf2",
          info: "#0288d1",
          infoLight: "#ffffff",
          infoContrast: "#ffffff",
          headerBackgroundColor: "#ffffff",
          headerPrimaryColor: '#99d6eb',
          footerBackgroundColor: "#ffffff",
          footerPrimaryColor: "#000000",
          trustElementBackgroundColor: '#ffffff',
        },
        font: {
            fontFamily: '"KlavikaWebBasic",sans-serif',
            headlineFontFamily: '"KlavikaWebBasic",sans-serif',
            fontSize: 16,
        },
        title: 'rhion.digital LinkedApp',
        logoSrc: process.env.REACT_APP_LINKEDAPP_BACKEND_ROOT + "/static/media/rhion-logo.svg",
        impressumSrc: 'https://www.rhion.digital/impressum/',
        agbSrc: 'https://rhion.digital/dipo/usage',
        datenschutzSrc: 'https://rhion.digital/fileadmin/redaktion/DOWNLOADS/Digitales_Postfach/20231207_Datenschutz_Digitales_Postfach.pdf',
        copyright: 'Rhion Versicherung AG',
        // kontaktdatenAendern: 'https://meinedaten.rhion.digital/#ihreDaten',
        faq: 'https://rhion.digital/kontakt/digitale-post/faq-digitales-postfach',
        homepage: 'https://www.rhion.digital',
        homepageTitle: 'rhion.digital',
        serviceTel: '02131 6099 0',
        serviceEmail: 'digitales-postfach-support@rhion.de',
      } as ThemeCustomizing;
    const breakpoints = createBreakpoints({})
    return createTheme({
        typography: {
          htmlFontSize: customizing?.font?.fontSize || 15,
          h1: {
              fontFamily: '"KlavikaWebBasic",sans-serif',
              fontWeight: 400,
              fontSize: '70px',
              color: '#000',
              textTransform: 'uppercase',
              [breakpoints.down('md')]: {
                  fontSize: '38px'
              },
              fontStyleHighlight: {
                  fontWeight: 700
              }
          },
          h2: {
              fontFamily: '"KlavikaWebBasic",sans-serif',
              fontWeight: 400,
              fontSize: '60px',
              color: '#000',
              [breakpoints.down('md')]: {
                  fontSize: '30px'
              },
              fontStyleHighlight: {
                  fontWeight: 700
              }
          },
          h3: {
              fontFamily: '"KlavikaWebBasic",sans-serif',
              fontWeight: 400,
              fontSize: '70px',
              color: '#000',
              [breakpoints.down('md')]: {
                  fontSize: '27px'
              },
              fontStyleHighlight: {
                  fontWeight: 700
              }
          },
            h4: {
                fontFamily: '"KlavikaWebBasic",sans-serif',
                fontWeight: 400,
                fontSize: '30px',
                color: '#000',
                [breakpoints.down('md')]: {
                    fontSize: '22px'
                },
                fontStyleHighlight: {
                    fontWeight: 700
                }
            },
            h5: {
                fontFamily: '"KlavikaWebBasic",sans-serif',
                fontWeight: 400,
                fontSize: '24px',
                color: '#000',
                [breakpoints.down('md')]: {
                    fontSize: '18px'
                },
                fontStyleHighlight: {
                    fontWeight: 700
                }
            },
            h6: {
                fontFamily: '"KlavikaWebBasic",sans-serif',
                fontWeight: 400,
                fontSize: '20px',
                color: '#000',
                [breakpoints.down('md')]: {
                    fontSize: '18px'
                },
                fontStyleHighlight: {
                    fontWeight: 700
                }
            },
            body1: {
                fontFamily: '"KlavikaWebBasic",sans-serif',
                fontSize: '18px',
                fontWeight: 400,
                color: '#000',
                [breakpoints.down('md')]: {
                    fontSize: '16px'
                },
                fontStyleHighlight: {
                    fontWeight: 600
                }
            },
            body2: {
                fontFamily: '"KlavikaWebBasic",sans-serif',
                fontSize: '14px',
                fontWeight: 400,
                color: '#000',
                fontStyleHighlight: {
                    fontWeight: 700
                },
                [breakpoints.down('md')]: {
                    fontSize: '14px',
                    fontStyleHighlight: {
                        fontWeight: 600
                    }
                }
            },
          fontFamily: customizing?.font?.fontFamily,
          fontWeightMedium: customizing?.font?.fontWeightMedium || 300,
          fontWeightLight: customizing?.font?.fontWeightLight || 100,
          fontWeightBold: customizing?.font?.fontWeightBold || 700,
          fontWeightRegular: customizing?.font?.fontWeightRegular || 300,
          fontSize: customizing?.font?.fontSize || 15,
        },
        palette: {
            primary: {
                main: "#99d6eb",
                dark: "#0099cc",
                light: "#e5f4f9"
            },
            secondary: {
                main: "#dbebce",
                dark: "#A4D084",
                light: "#f5faf2"
            },
            error: {
                main: "#e9e358",
            },
            warning: {
                main: "#e9e358",
            },
            success: {
                main: "#54ad4d",
            },
            info: {
                main: customizing?.colors?.info || '#ffffff',
                light: customizing?.colors?.infoLight || '#ffffff',
                contrastText: customizing?.colors?.infoContrast || '#0063ba',
            },
            footer: {
                main: customizing?.colors?.footerBackgroundColor || '#0069b4',
                //light: '#4444',
                contrastText: customizing?.colors?.footerPrimaryColor || '#4444'
            },
            header: {
                main: customizing?.colors?.headerBackgroundColor || '#0069b4',
                //light: '#4444',
                contrastText: customizing?.colors?.headerPrimaryColor || '#4444',
            },
        },
        components: {
          MuiInputLabel: {
            styleOverrides: {
              root: {
                fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
                '&.la': {
                  fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
                }
              }
            },
            defaultProps: {
              className: 'la'
            },
          },
          MuiFormLabel: {
            styleOverrides: {
              root: {
                zIndex: 1,
                fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
                '&.la': {
                  fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
                }
              }
            },
            defaultProps: {
              className: 'la'
            },
          },
          MuiFormHelperText: {
            styleOverrides: {
              root: {
                fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
              }
            }
          },
          MuiCircularProgress: {
            styleOverrides: {
              root: {
                color: customizing?.colors?.primaryContrast || '#ffffff',
              }
            }
          },
          MuiButton: {
            styleOverrides: {
              root: {
                '&:hover': {
                  backgroundColor: customizing?.colors?.primary || '#0069b4',
                  color: customizing?.colors?.primaryContrast || '#ffffff',
                  "@media (hover: none)": {
                    backgroundColor: customizing?.colors?.primary || '#0069b4',
                    color: customizing?.colors?.primaryContrast || '#ffffff',
                  },
                },
                '&.button-inline' :{
                  color: customizing?.colors?.primary,
                  border:'1px solid',
                  
                },
                lineHeight: 'initial',
                primary: customizing?.colors?.secondaryContrast || '#ffffff',
                '&.la': {
                    borderRadius: '30px',
                  background: customizing?.colors?.secondary || '#009767',
                  color: customizing?.colors?.secondaryContrast || '#ffffff',
                  padding: '0 30px',
                  '&:hover': {
                    backgroundColor: customizing?.colors?.primary || '#0069b4',
                    color: customizing?.colors?.primaryContrast || '#ffffff',
                    "@media (hover: none)": {
                      backgroundColor: customizing?.colors?.primary || '#0069b4',
                      color: customizing?.colors?.primaryContrast || '#ffffff',
                    },
                  },
                }
              },
              text: {
                '&.MuiButton-textPrimary': {
                  background: customizing?.colors?.primary,
                  color: customizing?.colors?.background,
                    fontWeight: '700'
                },
                '&.MuiButton-textPrimary.button-wizard-back': {
                  background: customizing?.colors?.background,
                  color: customizing?.colors?.primary,
                    border: `1px solid ${customizing?.colors?.primary}`
                },
                '&.MuiButton-textPrimary:hover': {
                    background: customizing?.colors?.background,
                    color: customizing?.colors?.primary,
                    border: `1px solid ${customizing?.colors?.primary}`
                },
                '&.MuiButton-textPrimary.Mui-disabled': {
                  color: customizing?.colors?.background,
                  background: '#e5e5e5',
                },
                // Some CSS
                //background: 'linear-gradient(45deg, #0069b4 30%, #009767 90%)',
                background: customizing?.colors?.secondary || '#009767',
                borderRadius: '10px',
                border: 0,
                color: customizing?.colors?.secondaryContrast || '#ffffff',
                primary: customizing?.colors?.secondaryContrast || '#ffffff',
                height: 48,
                padding: '0 30px',
                textTransform: "none"
              },
              ...customizing?.MuiButton?.styleOverrides,
            },
            defaultProps: {
              className: 'la'
            },
          },
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontWeight: "300",
                lineHeight: "1.5",
                color: "black",
                backgroundColor: "#ffffff",
                boxShadow: "rgba(0, 0, 0, 0.15) 2px 3px 3px",
                position: "absolute",
                top: "-15px",
                right: "-7px",
                minWidth: "450px",
                borderTopRightRadius: "0",
    
              },
              arrow: {
                "&:before": {
                  //border: "1px solid #E6E8ED"
    
                },
                //width: "24px",
                //height: "17px",
                color: "#ffffff",
                //color: "red",
                marginLeft: "218px",
                top: "40px",
    
              },
    
    
            },
          },

          MuiInputBase: {
            styleOverrides: {
                root: {
                    borderColor: 'blue',
                    "& > fiedset": {
                        borderColor: 'blue'
                    }
                }
            }
          },
    
    
          MuiCssBaseline: {
            styleOverrides: {
              html: {
                color: customizing?.colors?.font || '#181a1d',
                fontSize: '13pt',
                fontWeight: '300',
                fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
                backgroundColor: customizing?.colors?.backgroundColor || '#ffffff',
                background: customizing?.colors?.background || '#ffffff',
              },
              body: {
                color: customizing?.colors?.font || '#181a1d',
                fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
                backgroundColor: customizing?.colors?.backgroundColor || '#ffffff',
                background: customizing?.colors?.background || '#ffffff',
              },
              h1: {
                fontFamily: customizing?.font?.headlineFontFamily || 'Roboto, Helvetica, Arial, sans-serif',
              },
              ...customizing?.font?.styleOverrides ?? {},
              // Fix für Unschönheit im Mui-Datepicker. Kann evtl. mit neuer MUI-Version raus.
              ".MuiPickersDatePickerRoot-toolbar .MuiPickersToolbarButton-toolbarBtn": {
                backgroundColor: 'inherit',
                boxShadow: 'none'
              },
              // Fixes für die gemischte Verwendung des DatePickers mit alter JSS-Engine und Emotion aus MaterialUI 5.
              // Diese Hacks können verschwinden, sobald der offizielle DatePicker in V5 integriert wurde.
              ".MuiFormControl-root": {
                ".MuiFormLabel-root, .MuiInputLabel-root": {
                  fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
                  pointerEvents: 'none',
                },
                "&.datepicker .MuiFormLabel-root.MuiInputLabel-shrink": {
                  transform: 'translate(12px, 26px) scale(0.75)'
                },
                "&.datepicker .MuiInputLabel-formControl": {
                  zIndex: 1,
                  transform: 'translate(12px, 36px) scale(1)',
                  pointerEvents: 'none',
                },
                "&.datepicker .MuiInputBase-root.MuiInput-root.MuiInput-underline:hover": {
                  background: 'rgba(0, 0, 0, 0.09)'
                },
                "&.datepicker .MuiInputBase-root.MuiInput-root": {
                  borderTopLeftRadius: '4px',
                  borderTopRightRadius: '4px'
                },
                ".MuiInputBase-root": {
                  fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
                  background: '#ffffff',
                  backgroundColor: '#ffffff3b',
                },
                ".MuiInputBase-root input": {
                  fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
                  paddingTop: 25,
                  paddingRight: 12,
                  paddingBottom: 8,
                  paddingLeft: 12,
                },
                ".MuiInputBase-root.select": {
                  lineHeight: '2.385rem',
                  borderTopLeftRadius: '4px',
                  borderTopRightRadius: '4px'
                },
                "&.select .MuiSelect-select.MuiInput-input.MuiInputBase-input": {
                  paddingLeft: '8px',
                  paddingTop: '14px'
                },
                "&.select label.MuiInputLabel-root": {
                  lineHeight: '2.385rem',
                  transform: 'translate(12px, 20px) scale(1)'
                },
                "&.select label.MuiInputLabel-root.MuiInputLabel-shrink": {
                  transform: 'translate(12px, 14px) scale(0.75)',
                },
                ".MuiFormHelperText-root": {
                  color: '#00FF00',
                  fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
                },
                ".MuiInput-underline": {
                  "&::before": {
                    borderBottom: '1px solid',
                    borderBottomColor: customizing?.colors?.primary || '#ffffff',
                  },
                  "&:hover:not(.Mui-disabled):before": {
                    borderBottom: '2px solid',
                    borderBottomColor: customizing?.colors?.primary || '#ffffff',
                  },
                  "&::after": {
                    borderBottom: '2px solid',
                    borderBottomColor: customizing?.colors?.primary || '#ffffff',
                  }
                },
              },
              ".MuiPickersToolbar-toolbar": {
                backgroundColor: customizing?.colors?.backgroundColor || '#fafafa',
                background: customizing?.colors?.background || '#fafafa',
              },
              '.MuiStepper-root': {
                backgroundColor: 'transparent !important'
              },
              '.MuiStepContent-root': {
                color: customizing?.colors?.primary || '#ffffff'
              },
              '.MuiStepLabel-label': {
                '&.MuiStepLabel-completed': {
                  color: `${customizing?.colors?.primary} !important`
                },
                '&.MuiStepLabel-active': {
                  color: `${customizing?.colors?.primary} !important`
                },
              },
              '.MuiStepIcon-root': {
                '&.MuiStepIcon-completed': {
                  color: `${customizing?.colors?.primary} !important`
                },
                '&.MuiStepIcon-active': {
                  color: `${customizing?.colors?.primary} !important`
                },
              },
              '.answer-element-heading-info': {
                fontSize: '1.1rem',
                fontWeight: '600'
              },
    
              '&.textlinkInsteadOfButton': {
                textDecoration: 'underline',
                cursor: 'pointer',
                color: `${customizing?.colors?.primary} !important`
              },
              ...customizing?.baseline?.styleOverrides ?? {},
            },
          }
        },
      }, coreDeDE)
};